import { initProductCardSwatches } from './initProductCardSwatches';
import { createEkSlider, productSliderSwiperOverrides } from './ekSwiperSlider';

const SECTION_ATTR = 'data-similar-products-section';

async function loadSimilarProducts(sectionEl: HTMLElement): Promise<void> {
  const sectionId = sectionEl.dataset.sectionId;
  const productId = sectionEl.dataset.productId;
  if (!sectionId || !productId) return;

  if (sectionEl.dataset.similarInit === 'true') return;
  sectionEl.dataset.similarInit = 'true';

  const limit = sectionEl.dataset.limit || '8';
  const url = `/recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=related`;

  let html: string;
  try {
    const res = await fetch(url);
    if (!res.ok) return;
    html = await res.text();
  } catch {
    return;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const newSection = doc.querySelector<HTMLElement>(`[${SECTION_ATTR}]`);
  if (!newSection) return;

  sectionEl.innerHTML = newSection.innerHTML;
  sectionEl.style.cssText = '';

  const sliderEl = sectionEl.querySelector<HTMLElement>('[data-product-recommendations-slider]');
  const swiperEl = sectionEl.querySelector<HTMLElement>(`#recs-scroll-${sectionId}`);
  const items = sectionEl.querySelectorAll('[data-current-index]');
  if (!sliderEl || !swiperEl || !items.length) {
    sectionEl.style.cssText = 'display: none;';
    return;
  }

  // Claim the slider so initProductRecommendationsSlider skips this section.
  sliderEl.dataset.sliderInit = 'true';

  initProductCardSwatches(sectionEl);
  createEkSlider({
    sectionEl: sliderEl,
    sectionId,
    swiperEl,
    swiperOverrides: productSliderSwiperOverrides,
  });
}

function observeSection(sectionEl: HTMLElement): void {
  const observer = new IntersectionObserver(
    (entries, obs) => {
      if (entries[0].isIntersecting) {
        obs.disconnect();
        loadSimilarProducts(sectionEl);
      }
    },
    { rootMargin: '600px 0px' }
  );
  observer.observe(sectionEl);
}

export function initSimilarProductsSlider(root: ParentNode = document): void {
  const sections = root.querySelectorAll<HTMLElement>(`[${SECTION_ATTR}]`);
  sections.forEach((sectionEl) => observeSection(sectionEl));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initSimilarProductsSlider());
} else {
  initSimilarProductsSlider();
}

document.addEventListener('shopify:section:load', (e: Event) => {
  const target = (e as CustomEvent).target as HTMLElement | null;
  if (!target) return;
  const sectionEl = target.querySelector<HTMLElement>(`[${SECTION_ATTR}]`);
  if (sectionEl) loadSimilarProducts(sectionEl);
});
